module.exports = __webpack_public_path__ + "img/IMG_3962.bba11962.jpg";